import { FunctionComponent as F } from "react";
import loadingGif from '../../../../images/loading.gif';


const LoadingGifMedium: F = () =>
{
  return <img src={loadingGif} style={{ width: 100 }}/>;
};

export default LoadingGifMedium;
